import { AxiosError } from 'axios';
import { ServerResponse, WithAuditDetails } from 'data/types';
import { History } from 'history';
import { Dispatch, Action } from 'redux';
import { RootState } from 'data/root.reducers';
import i18n from 'i18n';
import { showSuccessMessage, showError } from 'shared/toaster';
import { ThunkDispatch } from 'redux-thunk';
import { extractErrorMessage } from '../../utils';
import * as api from './radiusParserOptions.api';
import {
  GET_RADIUS_PARSER_OPTIONS,
  UPDATE_RADIUS_PARSER_OPTIONS,
  GO_TO_RADIUS_PARSER_OPTIONS_EDIT,
  GO_TO_RADIUS_PARSER_OPTIONS_VIEW,
  GO_TO_RADIUS_PARSER_OPTIONS_CREATE,
  SET_RADIUS_PARSER_OPTIONS_LOADING,
  CREATE_RADIUS_PARSER_OPTIONS,
  UpdateRadiusParserOptionsThunkAction,
  SetRadiusParserOptionsLoadingAction,
  RadiusParserOptionsActionTypes,
  RadiusParserOptions,
  CreateRadiusParserOptionsThunkAction
} from './radiusParserOptions.types';
import { RADIUS_PARSER_OPTIONS, NETWORK, SYSTEM_CONFIGURATION_ROUTE } from '../../constants';

export function goToRadiusParserOptionsCreate(history: History): (dispatch: Dispatch) => void {
  return (dispatch: Dispatch) => {
    dispatch({
      type: GO_TO_RADIUS_PARSER_OPTIONS_CREATE,
    });

    history.push(`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${RADIUS_PARSER_OPTIONS}/`);
  };
}

export function goToRadiusParserOptionsEdit(history: History): (dispatch: Dispatch) => void {
  return (dispatch: Dispatch) => {
    dispatch({
      type: GO_TO_RADIUS_PARSER_OPTIONS_EDIT,
    });

    history.push(`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${RADIUS_PARSER_OPTIONS}/edit`);
  };
}

export function goToRadiusParserOptionsView(history: History): (dispatch: Dispatch) => void {
  return (dispatch: Dispatch) => {
    dispatch({
      type: GO_TO_RADIUS_PARSER_OPTIONS_VIEW,
    });

    history.push(`${SYSTEM_CONFIGURATION_ROUTE}${NETWORK}${RADIUS_PARSER_OPTIONS}`);
  };
}

export function setRadiusParserOptionsLoadingAction(
  isLoading: boolean,
): SetRadiusParserOptionsLoadingAction {
  return {
    type: SET_RADIUS_PARSER_OPTIONS_LOADING,
    payload: { isLoading },
  };
}

export function getRadiusParserOptions(
): RadiusParserOptionsActionTypes {
  return {
    type: GET_RADIUS_PARSER_OPTIONS,
    payload: api.getRadiusParserOptions(),
  };
}

export function updateRadiusParserOptions(
  id: string,
  body: WithAuditDetails<RadiusParserOptions>,
  history: History,
): UpdateRadiusParserOptionsThunkAction {
  return async (dispatch: ThunkDispatch<RootState, unknown, Action<string>>) => {
    try {
      await dispatch({
        type: UPDATE_RADIUS_PARSER_OPTIONS,
        payload: api.updateRadiusParserOptions(id, body),
      }) as any;

      dispatch(getRadiusParserOptions());
      dispatch(goToRadiusParserOptionsView(history));
      showSuccessMessage(i18n.t('radiusParserOptions.update.success'), 5000);

    } catch (e) {
      const errorMessage = extractErrorMessage(e as AxiosError<ServerResponse<void>>);
      showError(i18n.t('radiusParserOptions.update.failed', { error: errorMessage }));
    }
  };
}

export function createRadiusParserOptions(
  body: WithAuditDetails<RadiusParserOptions>,
  history: History,
): CreateRadiusParserOptionsThunkAction {
  return async (dispatch: ThunkDispatch<RootState, unknown, Action<string>>) => {
    try {
      await dispatch({
        type: CREATE_RADIUS_PARSER_OPTIONS,
        payload: api.createRadiusParserOptions(body),
      });

      dispatch(getRadiusParserOptions());
      dispatch(goToRadiusParserOptionsView(history));

      showSuccessMessage(i18n.t('radiusParserOptions.create.success'), 5000);

    } catch (e) {
      const errorMessage = extractErrorMessage(e as AxiosError<ServerResponse<void>>);
      showError(i18n.t('radiusParserOptions.create.failed', { error: errorMessage }));
    }
  };
}
